import { getEventPropsBuilder, toSnakeCase } from '../../utils';
import type { AmplitudeEventKeys } from '../../amplitude-properties.types';

export const REMINDER_MODULES = {
    PRE_LAUNCH: 'pre_launch',
    PRE_LAUNCH_POP_UP: 'pre_launch_pop_up'
} as const;

export type ReminderModule = (typeof REMINDER_MODULES)[keyof typeof REMINDER_MODULES];

type ReminderTrackingData = {
    module: ReminderModule;
    gameName: string;
};

export const buildReminderEvent = getEventPropsBuilder(
    (enabled: boolean, data: ReminderTrackingData): Partial<AmplitudeEventKeys> => {
        const eventProps: Partial<AmplitudeEventKeys> = {
            event: enabled ? 'Game Reminder Enabled' : 'Game Reminder Disabled',
            Module: data.module,
            'Game Name': toSnakeCase(data.gameName)
        };

        return eventProps;
    }
);
